import { withTranslations } from 'src/i18n/static-generation';
import type { PageMetas } from 'src/types/meta';
import CreatorProgram from 'src/views/CreatorProgram';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: false
  }
}));
const CreatorJoinPage = () => {
  return <CreatorProgram initialTab='azar_creator_join' data-sentry-element="CreatorProgram" data-sentry-component="CreatorJoinPage" data-sentry-source-file="creator-join.tsx" />;
};
export default CreatorJoinPage;